import AuthRouter from './Auth.router';

export default AuthRouter;

export { default as authRoutes } from './routes';
